export const environment = {
  production: false,
  development: true,
  test: false,

  domainUrl: 'https://snpmoney.com',
  storageUrl: 'https://snpmoney-dev.portalwiz.in/api/storage/app',
  baseUrl: 'https://snpmoney-dev.portalwiz.in/api/public/api',

  // Development specific settings
  apiVersion: 'v1',
  debugMode: true,
  enableLogging: true,
  cacheTimeout: 30000, // 30 seconds
  retryAttempts: 3,

  // Feature flags for development
  features: {
    enableMockData: true,
    enableErrorReporting: true,
    enablePerformanceMonitoring: true,
    enableDevTools: true
  },

  // Development server settings
  devServer: {
    port: 4200,
    host: 'localhost',
    open: true,
    hotReload: true
  }
};
